import appConfig from "../config/appConfig";
import { Role } from "../context/userinfo/types";
import { BaseRoutes } from "../utils/routes";

export const RouteAccessMap: {
  [path: string]: {
    default: Role[];
    [tenant: string]: Role[];
  };
} = {
  /*************************** FP Console Routes ***************************/
  "/fp-console/order-failure-code-list": {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  "/fp-console/order-failure-code": {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  "/fp-console/action-center": {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  "/fp-console": {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS, Role.ONDC_ANALYST],
  },
  "/fp-console/fp-account-details/tenants": {
    default: [Role.CYBRILLA_ADMIN],
  },

  "/fp-console/fp-account-details/tenants/new": {
    default: [Role.CYBRILLA_ADMIN],
  },
  "/fp-console/fp-account-details/user-management": {
    default: [Role.CYBRILLA_ADMIN],
  },
  "/fp-console/fp-account-details/user-management/new": {
    default: [Role.CYBRILLA_ADMIN],
  },
  "/fp-console/fp-account-details/user-management/root/new": {
    default: [Role.CYBRILLA_ADMIN],
  },
  "/fp-console/fp-account-details/user-management/:id": {
    default: [Role.CYBRILLA_ADMIN],
  },
  "/fp-console/pincodes": {
    default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  "/fp-console/ifsc-codes": {
    default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  "/fp-console/scheme-master-management": {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  "/fp-console/order-insights": {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.ONDC_ANALYST],
  },
  "/fp-console/health-metrics": {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  "/fp-console/api-metrics": {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  "/fp-console/kyc-insights": {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },

  /*************************** Operations routes ***************************/
  [`${BaseRoutes.OPERATIONS}/order-operations`]: {
    default: [
      Role.OPERATIONS,
      Role.TENANT_ORDER_OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_OPERATIONS,
      Role.OPERATIONS_ANALYST,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/order-operations/files/regenerate`]: {
    default: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.OPERATIONS}/order-operations/files`]: {
    default: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.OPERATIONS}/aging-orders`]: {
    default: appConfig.app.is_aging_orders_enabled
      ? [
          Role.OPERATIONS,
          Role.CYBRILLA_ADMIN,
          Role.TENANT_ORDERS_ANALYST,
          Role.TENANT_ORDER_OPERATIONS,
        ]
      : [],
  },
  [`${BaseRoutes.OPERATIONS}/order-operations/batch-files`]: {
    default: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.OPERATIONS}/feed-file`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [`${BaseRoutes.OPERATIONS}/ondc-transactions`]: {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.OPERATIONS}/ondc-transactions/:transaction_id`]: {
    default: [Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  [BaseRoutes.TRANSACTIONS]: {
    default: [
      Role.OPERATIONS,
      Role.TENANT_WORKFORCE,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.OPERATIONS,
      Role.TENANT_WORKFORCE,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/transfers`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/transfers/:transfer_reference`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [BaseRoutes.MF_FOLIOS]: {
    default: [
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.MF_FOLIOS}/:folio_number`]: {
    default: [
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/fund-schemes`]: {
    default: [
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/fund-schemes/scheme-details/:scheme_isin`]: {
    default: [
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.OPERATIONS}/order-operations/file-operations`]: {
    default: [Role.OPERATIONS, Role.TENANT_ORDER_OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.OPERATIONS}/blocked-bank-accounts`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.OPERATIONS}/manual-bank-account-verification`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [`${BaseRoutes.OPERATIONS}/manual-bank-account-verification/verify/:id`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  /*************************** Developer Routes ***************************/
  [BaseRoutes.DEVELOPERS]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.TENANT_WORKFORCE, Role.TENANT_ROOT],
    axismf: [],
  },
  [`${BaseRoutes.DEVELOPERS}/api-logs`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
    axismf: [],
  },
  [`${BaseRoutes.DEVELOPERS}/api-logs/:id`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
    axismf: [],
  },
  [BaseRoutes.MONITORING_ALERTS]: {
    default: appConfig.app.is_monitoring_alerts_enabled
      ? [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.OPERATIONS]
      : [],
    axismf: [],
  },
  [BaseRoutes.EVENTS]: {
    default: appConfig.app.is_events_enabled
      ? [Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN, Role.TENANT_WORKFORCE, Role.TENANT_ROOT]
      : [],
  },

  /*************************** Verification Routes ***************************/
  [BaseRoutes.VERIFICATIONS]: {
    default: [],
    ...Object.fromEntries(
      appConfig.app.verifications_enabled_tenants.map((tenant) => [
        tenant,
        [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.TENANT_INVESTOR_ANALYST, Role.CYBRILLA_ADMIN],
      ])
    ),
  },

  [BaseRoutes.PAN_VERIFICATIONS]: {
    default: [],
    ...Object.fromEntries(
      appConfig.app.verifications_enabled_tenants.map((tenant) => [
        tenant,
        [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.TENANT_INVESTOR_ANALYST, Role.CYBRILLA_ADMIN],
      ])
    ),
  },

  // Tenant gating for this page is not static: it is open to verifications-enabled tenants and to
  // AMC tenants, and AMC status is only known at runtime. Roles are therefore set on `default`, and
  // the tenant check is applied via `isKycStatusChecksAccessible` in the route and nav menu.
  [BaseRoutes.KYC]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.TENANT_INVESTOR_ANALYST,
      Role.CYBRILLA_ADMIN,
    ],
  },

  [BaseRoutes.BANK_ACCOUNT_VERIFICATION]: {
    default: [],
    ...Object.fromEntries(
      appConfig.app.verifications_enabled_tenants.map((tenant) => [
        tenant,
        [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.TENANT_INVESTOR_ANALYST, Role.CYBRILLA_ADMIN],
      ])
    ),
  },

  /*************************** Partner Routes ***************************/
  [BaseRoutes.PARTNERS]: {
    default: [
      Role.CYBRILLA_ADMIN,
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.TENANT_ROOT,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
      Role.TENANT_MEMBERSHIP_OPERATION,
      Role.TENANT_MEMBERSHIP_CHECKER,
      Role.TENANT_MEMBERSHIP_REVIEWER,
      Role.TENANT_MEMBERSHIP_APPROVER,
      Role.TENANT_MEMBERSHIP_MD,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
      Role.TENANT_MEMBERSHIP_OPERATION,
      Role.TENANT_MEMBERSHIP_CHECKER,
      Role.TENANT_MEMBERSHIP_REVIEWER,
      Role.TENANT_MEMBERSHIP_APPROVER,
      Role.TENANT_MEMBERSHIP_MD,
    ],
  },
  [`${BaseRoutes.PARTNERS}/new`]: {
    default: [
      Role.CYBRILLA_ADMIN,
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.TENANT_ROOT,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
    axismf: [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.CYBRILLA_ADMIN, Role.TEST],
  },
  [`${BaseRoutes.PARTNERS}/:partnerId`]: {
    default: [
      Role.CYBRILLA_ADMIN,
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.TENANT_ROOT,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
      Role.TENANT_MEMBERSHIP_OPERATION,
      Role.TENANT_MEMBERSHIP_CHECKER,
      Role.TENANT_MEMBERSHIP_REVIEWER,
      Role.TENANT_MEMBERSHIP_APPROVER,
      Role.TENANT_MEMBERSHIP_MD,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
      Role.TENANT_MEMBERSHIP_OPERATION,
      Role.TENANT_MEMBERSHIP_CHECKER,
      Role.TENANT_MEMBERSHIP_REVIEWER,
      Role.TENANT_MEMBERSHIP_APPROVER,
      Role.TENANT_MEMBERSHIP_MD,
    ],
  },
  [BaseRoutes.NETWORK_INTELLIGENCE]: {
    default: appConfig.app.is_network_intelligence_enabled
      ? [Role.CYBRILLA_ADMIN, Role.TENANT_MARKETING_ASSOCIATE, Role.CUSTOMER_SUCCESS]
      : [],
    axismf: appConfig.app.is_network_intelligence_enabled
      ? [
          Role.CYBRILLA_ADMIN,
          Role.TENANT_MARKETING_ASSOCIATE,
          Role.CUSTOMER_SUCCESS,
          Role.TENANT_ROOT,
        ]
      : [],
  },

  /*************************** FP Account Routes ***************************/
  [`${BaseRoutes.FP_ACCOUNT}/verifications`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/payments_gateway`]: {
    default: [Role.CUSTOMER_SUCCESS, Role.OPERATIONS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/mf_services`]: {
    default: [Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/amcs`]: {
    default: [Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/kyc-services`]: {
    default: [Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/advisory`]: {
    default: [Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/user_management`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/user-management/new`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT],
  },
  [`${BaseRoutes.FP_ACCOUNT}/user-management/:id`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT],
  },
  [`${BaseRoutes.FP_ACCOUNT}/bi-tool`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/feed-configuration`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [BaseRoutes.SCHEDULED_QUERIES]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT, Role.OPERATIONS],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [`${BaseRoutes.SCHEDULED_QUERIES}/:scheduled_query_id`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT, Role.OPERATIONS],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [BaseRoutes.NOTIFICATION_WEBHOOKS]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT, Role.OPERATIONS],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [`${BaseRoutes.NOTIFICATION_WEBHOOKS}/:webhook_id`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_ROOT, Role.OPERATIONS],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/fp-assist`]: {
    default: [Role.CYBRILLA_ADMIN],
  },
  [`${BaseRoutes.FP_ACCOUNT}/configuration-status`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.TENANT_ROOT],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/bank-settings`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/bank-settings/:id`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.FP_ACCOUNT}/bank-settings/new`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS],
  },

  /*************************** Feed Routes ***************************/
  [BaseRoutes.FEEDS]: {
    default: appConfig.app.are_feed_submission_pages_allowed
      ? [Role.OPERATIONS, Role.CYBRILLA_ADMIN]
      : [],
  },
  [BaseRoutes.FEED_SUBMISSION_JOBS]: {
    default: appConfig.app.are_feed_submission_pages_allowed
      ? [Role.OPERATIONS, Role.CYBRILLA_ADMIN]
      : [],
  },
  [BaseRoutes.FEED_SUBMISSIONS]: {
    default: appConfig.app.are_feed_submission_pages_allowed
      ? [Role.OPERATIONS, Role.CYBRILLA_ADMIN]
      : [],
  },

  /*************************** Order Routes ***************************/
  [BaseRoutes.ORDERS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.ORDERS}/overview`]: {
    default: [Role.CYBRILLA_ADMIN, Role.TENANT_OPERATIONS_ANALYST],
  },

  [BaseRoutes.MF_PURCHASES]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.MF_PURCHASES}/:purchaseId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [BaseRoutes.MF_REDEMPTIONS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.MF_REDEMPTIONS}/:redemptionId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [BaseRoutes.MF_SWITCHES]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },
  [`${BaseRoutes.MF_SWITCHES}/:switchId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },
  [BaseRoutes.MF_PURCHASE_PLANS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.MF_PURCHASE_PLANS}/:purchasePlanId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [BaseRoutes.MF_REDEMPTION_PLANS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [`${BaseRoutes.MF_REDEMPTION_PLANS}/:redemptionPlanId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [BaseRoutes.MF_SWITCH_PLANS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [`${BaseRoutes.MF_SWITCH_PLANS}/:switchPlanId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
    ],
  },
  [`${BaseRoutes.ORDERS}/orders-trend`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.TENANT_BUSINESS_ANALYST],
    axismf: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.TENANT_BUSINESS_ANALYST, Role.TENANT_ROOT],
  },

  /*************************** Metrics Routes ***************************/
  [`${BaseRoutes.METRICS}/product-usage`]: {
    default: [Role.CYBRILLA_ADMIN, Role.OPERATIONS, Role.CUSTOMER_SUCCESS, Role.TEST],
  },

  /*************************** Payment Routes ***************************/
  [BaseRoutes.PAYMENTS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },
  [BaseRoutes.PAYOUTS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.PAYOUTS}/:payoutId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.ORDERFEED]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.ORDERFEED}/:orderFeedId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.RECON]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.RECON}/:reconId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.DEPOSIT_RECEIPTS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.DEPOSIT_RECEIPT_ADJUSTMENTS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.DEPOSIT_RECEIPT_ADJUSTMENTS}/:depositReceiptAdjustmentId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.RECON_ADJUSTMENTS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.RECON_ADJUSTMENTS}/:reconAdjustmentId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.SETTLEMENT_INSTRUCTIONS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.SETTLEMENT_INSTRUCTIONS}/:settlementInstructionId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.SETTLEMENT_REPORT_FILES]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.DEPOSIT_RECEIPTS}/:depositReceiptId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [BaseRoutes.BANK_ACCOUNT_STATEMENTS]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.BANK_ACCOUNT_STATEMENTS}/:bankAccountStatementId`]: {
    default: [],
    ncnccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
    nccl: [
      Role.CYBRILLA_ADMIN,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.OPERATIONS,
      Role.CUSTOMER_SUCCESS,
    ],
  },
  [`${BaseRoutes.PAYMENTS}/:paymentId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },
  [BaseRoutes.MANDATES]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },
  [`${BaseRoutes.MANDATES}/:mandateId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_SETTLEMENT_ASSOCIATE,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
    ],
  },

  /*************************** Investors Routes ***************************/

  [BaseRoutes.MF_INVESTMENT_ACCOUNTS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [`${BaseRoutes.MF_INVESTMENT_ACCOUNTS}/:mfiaId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TENANT_ORDERS_ANALYST,
    ],
  },
  [BaseRoutes.INVESTORS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [`${BaseRoutes.INVESTORS}/:investorId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [BaseRoutes.INVESTOR_PROFILES]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [`${BaseRoutes.INVESTOR_PROFILES}/:investorProfileId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [BaseRoutes.BANK_ACCOUNT_VERIFICATIONS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TEST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
      Role.TEST,
    ],
    ...Object.fromEntries(
      appConfig.app.verifications_enabled_tenants.map((tenant) => [tenant, []])
    ),
  },
  [BaseRoutes.INVESTOR_PROFILE_NON_INDIVIDUALS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [`${BaseRoutes.INVESTOR_PROFILE_NON_INDIVIDUALS}/:nonIndividualInvestorProfileId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },

  [BaseRoutes.KYC_FORMS]: {
    default: [],
    ...(appConfig.app.is_kyc_forms_pages_enabled
      ? Object.fromEntries(
          appConfig.app.poa_tenants.map((tenant) => [
            tenant,
            [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
          ])
        )
      : {}),
  },
  [`${BaseRoutes.KYC_FORMS}/:kycFormId`]: {
    default: [],
    ...(appConfig.app.is_kyc_forms_pages_enabled
      ? Object.fromEntries(
          appConfig.app.poa_tenants.map((tenant) => [
            tenant,
            [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
          ])
        )
      : {}),
  },
  [BaseRoutes.KYC_REQUESTS]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },
  [`${BaseRoutes.KYC_REQUESTS}/:kycRequestId`]: {
    default: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ROOT,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
    axismf: [
      Role.CUSTOMER_SUCCESS,
      Role.OPERATIONS,
      Role.CYBRILLA_ADMIN,
      Role.TENANT_ASSOCIATE_WORKFORCE,
      Role.TENANT_WORKFORCE,
      Role.TEST,
      Role.TENANT_INVESTOR_ANALYST,
    ],
  },

  /*************************** Support Routes ***************************/
  [`${BaseRoutes.SUPPORT}/issues`]: {
    default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.SUPPORT}/issues/new`]: {
    default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
  [`${BaseRoutes.SUPPORT}/issues/:issueId`]: {
    default: [Role.CYBRILLA_ADMIN, Role.CUSTOMER_SUCCESS],
  },
};

const getMenuRolesForPath = (checkPath: string, tenant?: string | null, matchExact = false) => {
  const expression = new RegExp(matchExact ? `^${checkPath}$` : `^${checkPath}`);

  const validRoles = Object.entries(RouteAccessMap).reduce((prev, [path, roleObject]) => {
    if (expression.test(path)) {
      const roles = roleObject[tenant!] ?? roleObject["default"];
      roles?.forEach((role) => prev.add(role));
    }
    return prev;
  }, new Set<Role>());

  return Array.from(validRoles);
};

// Get the list of roles for a given menu by checking all matching route prefixes.
// Accepts a single route or multiple routes when submenu items do not share a common prefix.
export const getMenuRoles = (
  checkPath: string | string[],
  tenant?: string | null,
  matchExact = false
) => {
  const checkPaths = Array.isArray(checkPath) ? checkPath : [checkPath];

  const validRoles = checkPaths.reduce((prev, path) => {
    getMenuRolesForPath(path, tenant, matchExact).forEach((role) => prev.add(role));
    return prev;
  }, new Set<Role>());

  return Array.from(validRoles);
};
